import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { BacDashboardInformation } from "../../../../core/models/dashboard-poc/bacDashboardInformation";
import { BilledOrdersYtdResponse } from "../../../../core/models/dashboard-poc/billedOrdersYtdResponse";
import { Router } from "@angular/router";
import { BacDashboardInformationRequest } from "../../../../core/models/dashboard-poc/bacDashboardInformationRequest";
import { BacDashboardDto } from "../../../../core/models/dashboard-poc/bacDashboardDto";
import { BCLedgerFilter } from "../../../../core/models/bcLedger/bclegderfilter";
import { YtdSummaryData } from "../../../../core/models/bcLedger/ytdSummaryDataDto";
import { YtdSummaryRequestDto } from "../../../../core/models/bcLedger/ytdSummaryRequestDto";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { Employee } from "../../../../core/models/profile/employee";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { BcledgerService } from "../../../../core/services/bcledger.service";
import { CommonService } from "../../../../core/services/common.service";
import { DashboardPocService } from "../../../../core/services/dashboard-poc.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SharedService } from "../../../../core/services/shared.service";
import { UserSupportMapService } from "../../../../core/services/user-support-map.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { BcledgerFilterComponent } from "../../../bcledger/components/bcledger-filter/bcledger-filter.component";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { LocationWiseQ3Grid1Component } from "../location-wise-q3-grid1/location-wise-q3-grid1.component";
import { LocationWiseQ3Grid2Component } from "../location-wise-q3-grid2/location-wise-q3-grid2.component";
import { BilledOrdersYtdChartComponent } from "../billed-orders-ytd-chart/billed-orders-ytd-chart.component";
import { QuarterlySupportTableComponent } from "../quarterly-support-table/quarterly-support-table.component";
import { YearToDateSummaryComponent } from "../../../bcledger/components/year-to-date-summary/year-to-date-summary.component";
import { BcBacSupportBreakdownComponent } from "../bc-bac-support-breakdown/bc-bac-support-breakdown.component";
import { BacOrdersBreakdownChartComponent } from "../bac-orders-breakdown-chart/bac-orders-breakdown-chart.component";
import { Q3ReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3ReportLocationWiseBcReportDto";
import { Q3SecondGridReportLocationWiseBcReportDto } from "../../../../core/models/dashboard-poc/q3SecondGridReportLocationWiseBcReportDto";
import { CommonModule } from "@angular/common";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";

@Component({
  selector: "jni-bc-report",
  templateUrl: "./bc-report.component.html",
  styleUrls: ["./bc-report.component.scss"],
  imports: [
    BcledgerFilterComponent,
    LocationWiseQ3Grid1Component,
    LocationWiseQ3Grid2Component,
    BilledOrdersYtdChartComponent,
    QuarterlySupportTableComponent,
    YearToDateSummaryComponent,
    BcBacSupportBreakdownComponent,
    BacOrdersBreakdownChartComponent,
    CommonModule,
  ],
})
export class BcReportComponent implements OnInit {
  ytdSummaryList: YtdSummaryData[] = [];
  bcLedgerFilter: BCLedgerFilter = {} as BCLedgerFilter;
  bacDashboardInformation: BacDashboardDto = {} as BacDashboardDto;
  billedOrdersYTD: BilledOrdersYtdResponse[] = [];
  userData!: GetUserDto;
  bcList: Employee[] = [];
  brandingConsultantSection = false;
  showBrandingConsultantWhoSupportsMeDropDown = false;
  userRole = 0;
  personalNumber = "";
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  currentSupportPercentage = 0;
  nextCommissionTier = 0;
  nextToGpCommission = 0;

  isBAC = false;

  isManager = false;

  manager = false;
  isSuperManager = false;
  disableDropDown = false;

  grid1: Q3ReportLocationWiseBcReportDto[] = [];
  grid2: Q3SecondGridReportLocationWiseBcReportDto[] = [];

  location = "";

  overrideManager = false;
  showRemoveFilter = false;

  fromDate!: string;
  toDate!: string;

  bcSelectedId = "";

  selectedDateRange = "Current YTD";

  callDateSelection = true;

  rollingTwelveMonthGp = 0;
  rollingTwelveMonthRevenue = 0;

  qr4 = [
    { support: 25, q4GP: 212_500 },
    { support: 50, q4GP: 425_000 },
    { support: 75, q4GP: 637_500 },
    { support: 100, q4GP: 850_000 },
  ] as { support: number; q4GP: number }[];

  orderListingDisplayModal = false;

  @Output() openOrderListingModal = new EventEmitter<boolean>();
  @Output() populateEvent = new EventEmitter<BcLedgerStacker>();

  @ViewChild("filter", { static: false }) filter!: BcledgerFilterComponent;

  constructor(
    private _loaderService: LoaderService,
    private _dashboardPocService: DashboardPocService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _bcledgerService: BcledgerService,
    private _toastr: JniToastrService,
    private _commonService: CommonService,
    private _sharedService: SharedService,
    private _userSupportMapService: UserSupportMapService,
    private _router: Router
  ) {
    const bcLedgerFilterRoute = this._router.getCurrentNavigation()?.extras
      ?.state?.["bcLedgerFilter"] as BCLedgerFilter;

    if (bcLedgerFilterRoute) {
      this.fromDate = new Date(
        `${bcLedgerFilterRoute.fromDate}T00:00:00`
          .replace(/-/g, "/")
          .replace(/T.+/, "")
      ).toISOString();
      this.toDate = new Date(
        `${bcLedgerFilterRoute.toDate}T00:00:00`
          .replace(/-/g, "/")
          .replace(/T.+/, "")
      ).toISOString();
      this.bcSelectedId = bcLedgerFilterRoute.brandingConsultantID ?? "";
      this.selectedDateRange = bcLedgerFilterRoute.dateRange ?? "Current YTD";
      this.callDateSelection = false;
      this.bcLedgerFilter = { ...bcLedgerFilterRoute };
    }
  }

  ngOnInit() {
    this.getUserProfile();
  }

  GetSalesOrderBacInformationForCharts() {
    this._loaderService.setLoaderState(true);
    this.bacDashboardInformation.bacDashboardInformation = [];
    this.bacDashboardInformation.totalBillGp = 0;
    this.bacDashboardInformation.totalOpenGP = 0;
    this.bacDashboardInformation.totalSupportPercentage = 0;
    this.currentSupportPercentage = 0;
    this._dashboardPocService
      .GetSalesOrderBacInformationForCharts(this.getCurrentYtdLogic())
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.bacDashboardInformation = res.data;
            let supportPercentageSum = 0;

            this.bacDashboardInformation.bacDashboardInformation.forEach(x => {
              supportPercentageSum += x.supportPercentage;
            });
            this.currentSupportPercentage = supportPercentageSum;

            this.calculateGp();

            // this.nextCommissionTier =
            //   (Math.floor(this.currentSupportPercentage / 100) +
            //     1 -
            //     this.currentSupportPercentage / 100) *
            //   212500;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  calculateGp() {
    const data = this.bacDashboardInformation.bacDashboardInformation.find(
      x => x.supportBreakDown == "Others"
    );

    const ytdp = this.ytdSummaryList[0];

    if (
      !data &&
      ytdp &&
      typeof ytdp.YTGP == "number" &&
      this.bacDashboardInformation &&
      typeof this.bacDashboardInformation.totalBillGp == "number" &&
      ytdp.YTGP > this.bacDashboardInformation.totalBillGp
    ) {
      const others = {
        bcNumber: "-",
        orderCount: 0,
        isActive: false,
        supportBreakDown: "Others",
        supportPercentage: 0,
        title: "-",
        totalBillGp: ytdp.YTGP - this.bacDashboardInformation.totalBillGp,
        totalOpenGP: 0,
      } as BacDashboardInformation;

      this.bacDashboardInformation.bacDashboardInformation = [
        ...this.bacDashboardInformation.bacDashboardInformation,
        others,
      ];
    }
  }

  getBilledOrdersYTD() {
    this._loaderService.setLoaderState(true);
    this.billedOrdersYTD = [];
    this._dashboardPocService
      .getBilledOrdersYTD(this.getCurrentYtdLogic())
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this.billedOrdersYTD = res.data;
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }
  rollingTwelveMonth() {
    this._loaderService.setLoaderState(true);
    const ytdLogic = this.getCurrentYtdLogic();

    let personalNumber = "";
    if (ytdLogic) {
      personalNumber = ytdLogic?.personnelNumber ?? "";
    }

    this._dashboardPocService.rollingTwelveMonth(personalNumber).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        const rollingGp = res.data;
        if (rollingGp) {
          this.rollingTwelveMonthGp = rollingGp.runningtwelveMonthGp;
          this.rollingTwelveMonthRevenue = rollingGp.runningtwelveMonthVolume;
          this.nextCommissionTier = (rollingGp.gpAverage / 850000) * 100;
          // this.calculateSupport(rollingGp.gpAverage);
          this.calculateRemainingAmount(rollingGp.gpAverage);
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this.rollingTwelveMonthGp = 0;
        this.rollingTwelveMonthRevenue = 0;
        // this.calculateSupport(this.rollingTwelveMonthGp);
        this.calculateRemainingAmount(this.rollingTwelveMonthGp);
      },
    });
  }

  getCurrentYtdLogic() {
    const obj: BacDashboardInformationRequest = {
      fromDate: this.bcLedgerFilter.fromDate,
      toDate: this.bcLedgerFilter.toDate,
      personnelNumber: "",
    };

    if (this.userRole == UserRole.Admin) {
      obj.personnelNumber = this.bcLedgerFilter.brandingConsultantID;
    } else {
      obj.personnelNumber =
        this.bcLedgerFilter.brandingConsultantID ??
        this.userData.personnelNumber ??
        "";
    }

    return obj;
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;

        this.getUserById(res?.data?.userId);

        if (this.userRole != UserRole.Admin) {
          // this.changeBrandingConsultant();
        }
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.manager = res?.data?.managerAccess;
          this.isSuperManager = res?.data?.superManagerAccess;

          if (this.userRole === UserRole.Admin || this.isSuperManager) {
            this.brandingConsultantSection = true;
            this.showBrandingConsultantWhoSupportsMeDropDown = false;
            this.getAllBrandingConsultantDashboardPoc();
          }

          if (this.userRole != UserRole.Admin && !this.isSuperManager) {
            if (this.manager) {
              this.brandingConsultantSection = true;
              this.showBrandingConsultantWhoSupportsMeDropDown = false;
              this.getAllBrandingConsultantWithSameLocation();
              this.disableDropDown = true;
              this.filter.bcSelectedId = this.userData.personnelNumber;
            } else {
              this.brandingConsultantSection = true;
              this.showBrandingConsultantWhoSupportsMeDropDown = false;
              // this.disableDropDown = true;
              this.selectBcData();
              this.bcSelectedId = this.userData.personnelNumber;
              this.getMultiLedgerAssociations();
            }
            // if (
            //   res?.data.loginEmail &&
            //   res?.data?.title?.toLowerCase()?.includes('branding consultant')
            // ) {
            //   this.getWhoeSupportsMeBrandingConsultant(res.data.loginEmail);
            // } else {
            //   this.isBAC = true;
            // }
            this.changeBrandingConsultant();
          }
          //  if(this.userRole == UserRole.Admin)
          //   {
          //     this.getYtdSummary();
          //   }
        }
      },
    });
  }

  selectBcData() {
    this.bcList = [
      {
        firstName: this.userData.name,
        personnelNumber: this.userData.personnelNumber,
      },
    ];
  }

  getAllBrandingConsultantWithSameLocation() {
    this._commonService.getAllBrandingConsultantWithSameLocation().subscribe({
      next: res => {
        this.bcList = res.data;
      },
    });
  }

  getYtdSummary() {
    if (this.userRole == UserRole.Admin) {
      this.personalNumber = this.bcLedgerFilter.brandingConsultantID ?? "";
    } else {
      this.personalNumber =
        this.bcLedgerFilter?.brandingConsultantID ??
        this.userData.personnelNumber ??
        "";
    }

    if (this.personalNumber == undefined || this.personalNumber == "") {
      return;
    }
    // const ytdDates = this.getCurrentYtdLogic();

    const currentDate = new Date();
    const toDate = `${
      currentDate.getMonth() + 1
    }/${currentDate.getDate()}/${currentDate.getFullYear()}`;
    const fromDate = new Date(currentDate);
    fromDate.setFullYear(currentDate.getFullYear() - 1);

    if (currentDate.getDate() !== fromDate.getDate()) {
      fromDate.setDate(0);
    }

    const fromDateString = `${
      fromDate.getMonth() + 1
    }/${fromDate.getDate()}/${fromDate.getFullYear()}`;

    const ytdSummaryPayload: YtdSummaryRequestDto = {
      FromDate: fromDateString,
      ToDate: toDate,
      BrandingConsultantID: this.personalNumber,
    };

    this._loaderService.setLoaderState(true);
    this._bcledgerService.ytdSummary(ytdSummaryPayload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data != null) {
          const summary = res.data.Data ?? [];
          this.ytdSummaryList = summary.map(x => {
            const ytdGpDivide = Math.floor(
              (x.YTGP / this.qr4[this.qr4.length - 1].q4GP) * 100
            );

            this.calculateGp();

            const { currentTier, nextTier } = this.getCurrentAndNextTierValue(
              ytdGpDivide,
              x.YTGP
            );
            x.CommissionTierDashboard = currentTier;
            x.NextCommissionTier = nextTier;
            return x;
          });

          //const ytgp = this.ytdSummaryList[0]?.YTGP || 0;
          // this.calculateSupport(ytgp);
          // this.calculateRemainingAmount(ytgp);
        }
        if (res?.status?.toLowerCase() !== "success") {
          this._toastr.error("YTD Error", res.message || "YTD Error");
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getCurrentAndNextTierValue(ytdGpDivide: number, ytgp: number) {
    for (let i = 0; i < this.qr4.length; i++) {
      if (i == 0 && ytdGpDivide < this.qr4[i].support) {
        return {
          currentTier: 0,
          nextTier: Math.abs((this.qr4[i].q4GP || 0) - ytgp),
        } as { currentTier: number; nextTier: number };
      }

      if (
        i + 1 != this.qr4.length &&
        ytdGpDivide >= this.qr4[i].support &&
        ytdGpDivide < this.qr4[i + 1].support
      ) {
        return {
          currentTier: this.qr4[i].support,
          nextTier: this.qr4[i + 1].q4GP - ytgp,
        } as { currentTier: number; nextTier: number };
      }

      if (i + 1 == this.qr4.length) {
        return { currentTier: ytdGpDivide, nextTier: 0 } as {
          currentTier: number;
          nextTier: number;
        };
      }
    }

    return { currentTier: 0, nextTier: 0 } as {
      currentTier: number;
      nextTier: number;
    };
  }

  getAllBrandingConsultantDashboardPoc() {
    this._commonService.getAllBrandingConsultantDashboardPoc().subscribe({
      next: res => {
        this.bcList = res.data;
      },
    });
  }

  getWhoeSupportsMeBrandingConsultant(loggedInEmail: string) {
    this._userSupportMapService
      .whoSupportMeWithPersonalNumberDashboardPoc(loggedInEmail)
      .subscribe({
        next: res => {
          this.bcList = res.data;
        },
      });
  }

  changeBrandingConsultant() {
    if (
      this.userRole !== 0 &&
      this.bcLedgerFilter.brandingConsultantID != undefined &&
      this.userRole === UserRole.Admin &&
      this.bcLedgerFilter.brandingConsultantID != ""
    ) {
      const ytdLogic = this.getCurrentYtdLogic();
      this.dashbaordPocAdditionalFilters.brandingConsultant =
        ytdLogic.personnelNumber ?? "";
      this.dashbaordPocAdditionalFilters.fromDate = ytdLogic.fromDate ?? "";
      this.dashbaordPocAdditionalFilters.toDate = ytdLogic.toDate ?? "";
      this._sharedService.setDashbaordPocAdditionalFiltersObject(
        this.dashbaordPocAdditionalFilters
      );
      this.GetSalesOrderBacInformationForCharts();
      this.getBilledOrdersYTD();
      this.getYtdSummary();
      this.rollingTwelveMonth();
    } else if (this.userRole !== 0 && this.userRole !== UserRole.Admin) {
      const ytdLogic = this.getCurrentYtdLogic();
      this.dashbaordPocAdditionalFilters.brandingConsultant =
        ytdLogic.personnelNumber ?? "";
      this.dashbaordPocAdditionalFilters.fromDate = ytdLogic.fromDate ?? "";
      this.dashbaordPocAdditionalFilters.toDate = ytdLogic.toDate ?? "";
      this._sharedService.setDashbaordPocAdditionalFiltersObject(
        this.dashbaordPocAdditionalFilters
      );
      this.GetSalesOrderBacInformationForCharts();
      this.getBilledOrdersYTD();
      this.getYtdSummary();
      this.rollingTwelveMonth();
    }
  }

  getBcLedgerFormData(bcLedgerFilter: BCLedgerFilter) {
    this.bcLedgerFilter = { ...bcLedgerFilter };
    this.changeBrandingConsultant();
    // this.showRemoveFilter = true;
  }

  getQ3ReportLocationWiseBcReport() {
    this._dashboardPocService.getQ3ReportLocationWiseBcReport().subscribe({
      next: res => {
        if (res.status.toLowerCase() == "success") {
          this.grid1 = res.data;
        } else {
          this.grid1 = [];
          this._toastr.error(
            "Error",
            res.message || "Error fetching location wise report grid 1"
          );
        }
      },
      error: () => {
        this.grid1 = [];
        this._toastr.error(
          "Error",
          "Error fetching location wise report grid 1"
        );
      },
    });
  }

  getQ3SecondGridReportLocationWiseBcReport() {
    this._dashboardPocService
      .getQ3SecondGridReportLocationWiseBcReport()
      .subscribe({
        next: res => {
          if (res.status.toLowerCase() == "success") {
            this.grid2 = res.data;
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error fetching location wise report grid 2"
            );
            this.grid2 = [];
          }
        },
        error: () => {
          this._toastr.error(
            "Error",
            "Error fetching location wise report grid 2"
          );
          this.grid2 = [];
        },
      });
  }

  calculateSupport(commission: number) {
    const baseCommission = 212500;
    const supportStep = 25;
    const index = Math.ceil(commission / baseCommission) - 1;

    if (index >= 0) {
      this.nextCommissionTier = (index + 1) * supportStep;
    }
  }

  calculateRemainingAmount(commission: number) {
    const baseCommission = 212500;
    const index = Math.floor(commission / baseCommission);

    if (index >= 0) {
      const nextCommission = (index + 1) * baseCommission;
      this.nextToGpCommission = nextCommission - commission;
    }
  }

  removeFilter(event: boolean) {
    this.overrideManager = true;
    this.isManager = false;
    if (event) {
      this.ngOnInit();
    }
  }

  bcSelectedEvent() {
    // this.showRemoveFilter = true;
  }

  removeFilterButtonEvent() {
    this.filter.bcSelectedId = "";
    this.bcSelectedId = "";
    this.grid1 = [];
    this.location = "";
    this.bacDashboardInformation = {} as BacDashboardDto;
    // this.dashbaordPocAdditionalFilters = {};
    this.grid2 = [];
    this.bacDashboardInformation = {} as BacDashboardDto;
    // this.dashbaordPocAdditionalFilters = {};
    this.billedOrdersYTD = [];
    this.ytdSummaryList = [];
    this.bcLedgerFilter = {};
    this.currentSupportPercentage = 0;
    this.nextCommissionTier = 0;
    this.overrideManager = false;
    this.isManager = false;
    this.filter.ngOnInit();
    this.ngOnInit();
    this.showRemoveFilter = false;
  }

  showFilterButton() {
    this.showRemoveFilter = true;
  }

  getMultiLedgerAssociations() {
    this._loaderService.setLoaderState(true);
    this._dashboardPocService
      .getMultiLedgerAssociations(this.bcSelectedId)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data?.length) {
            this.bcList = [
              ...this.bcList,
              ...res.data.map(
                x =>
                  ({
                    firstName: x.name,
                    personnelNumber: x.associatedBCPersonnelNumber,
                  }) as Employee
              ),
            ];
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  openOrderListingModalEmitter(flag: boolean) {
    // this.orderListingDisplayModal = flag;
    this.openOrderListingModal.emit(flag);
  }
  closeOrderListingModal() {
    // this.closeSalesOrderModel.emit(true);
    this.orderListingDisplayModal = false;
  }

  populate(bcLedgerStackerEvent: BcLedgerStacker) {
    this.populateEvent.emit(bcLedgerStackerEvent);
  }
}
